import { ISelectOption } from "components/common/CustomSelect";

const specialFilterSelect: ISelectOption[] = [
    { value: '', label: '기본' },
    { value: 'priceDESC', label: '가격 높은순' },
    { value: 'priceASC', label: '가격 낮은순' },
    { value: 'expireASC', label: '유효기간 짧은순' },
    { value: 'expireDESC', label: '유효기간 긴순' },
]

export {
    specialFilterSelect
}